<ion-header class="ion-no-border">
    <ion-toolbar color="primary">
        <izivia-back-button tappable (click)="back()"></izivia-back-button>

        <ion-title>{{'support.choiceTitle' | translate}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card>
        <ion-card-content>
            <ng-container *ngIf="displayTechnicalSupportContactOrDefaultMessage">
                <ion-item *ngIf="!!technicalSupportContact"
                          class="card-content"
                          detail="false"
                          (click)="openSupportContact(technicalSupportContact)">
                    <ion-text>
                        <div>{{technicalSupportContact.name}}</div>
                        <div [innerHTML]="technicalSupportContact.description" class="contactValue"></div>
                    </ion-text>
                    <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
                </ion-item>
                <ion-item *ngIf="!technicalSupportContact"
                          class="card-content"
                          detail="false">
                    <ion-text>
                        <div>{{'support.technicalSupport' | translate}}</div>
                        <div class="contactValue">{{'support.callStationPhoneNumber' | translate}}</div>
                    </ion-text>
                </ion-item>
            </ng-container>
            <ion-item *ngFor="let supportContact of supportContacts; trackBy: trackById"
                      class="card-content"
                      (click)="openSupportContact(supportContact)"
                      detail="false">
                <ion-text>
                    <div>{{supportContact.name}}</div>
                    <div [innerHTML]="supportContact.description" class="contactValue"></div>
                </ion-text>
                <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
            </ion-item>
        </ion-card-content>
    </ion-card>
</ion-content>

